// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"88a43d93","17":"6ea658f8","75":"86e9d7f7","78":"cea3b77b","227":"dd7d11a7","270":"14aebfdd","356":"996ad9cd","583":"a763c968","584":"195decb4","658":"e2a17b5d","787":"006ed6e0","881":"25bb94a4","935":"bc1f6470"}[chunkId] + ".chunk.js";
};